<template>
  <div>
    <v-autocomplete
      v-if="isBrazilSelectedCountry"
      v-validate="validator"
      :value="value"
      label="Cidade"
      :items="cidadesFiltradas"
      no-data-text="Nenhuma cidade encontrada"
      data-vv-validate-on="change|input"
      item-text="Nome"
      return-object
      :disabled="disabled"
      autocomplete="false"
      outlined
      :class="[(errors.first(field) || error) && 'block']"
      single-line
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config"
      @input="$emit('input', $event)"
    />
    <v-text-field
      v-else
      v-validate="validator"
      outlined
      label="Cidade"
      :value="value"
      :class="[(errors.first(field) || error) && 'block']"
      :name="field"
      :disabled="disabled"
      :error-messages="errors.first(field)"
      v-bind="config"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { data as cidades } from '@/config/cidades.json'

export default {
  inject: ['$validator'],
  props: {
    value: [Object, String],
    field: String,
    config: Object,
    selectedCountryLocal: String,
    validator: Object,
    disabled: Boolean,
    uf: String
  },
  data: () => ({
    cidades: cidades,
    error: null
  }),
  computed: {
    isBrazilSelectedCountry() {
      return this.selectedCountryLocal === 'BRASIL'
    },
    cidadesFiltradas() {
      return this.cidades.filter(cidade => cidade.Uf === this.uf)
    }
  }
}
</script>

<style></style>
